import { PlateManufacturer, PlateType } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

// This function is based on the server side PlateTypeExtensions.GetManufacturer
export function getPlateManufacturer(plateType: PlateType): PlateManufacturer {
  switch (plateType) {
    case 'TL16':
    case 'TL18':
    case 'TL20':
    case 'MT16':
    case 'MT18':
    case 'MT20':
    case 'M20HS':
    case 'M18SHS':
    case 'M20':
    case 'M16':
    case 'MT18HS':
    case 'MII16':
    case 'M18AHS':
    case 'MII20':
    case 'MII20HS':
    case 'MT20HS':
    case 'MTH18':
    case 'SMH18':
      return 'MiTek';
    case 'Eagle16':
    case 'Eagle18':
    case 'Eagle20':
    case 'Eagle18HS':
    case 'Eagle20HS':
      return 'Eagle';
    case 'AS20':
    case 'AS18HS': // aka AS18
    case 'AS18S6':
    case 'AS18S5':
    case 'AS20HS':
      return 'Simpson';
    case 'Alpine20H':
    case 'AlpineT':
    case 'Alpine18SS':
    case 'AlpineW':
      return 'Alpine';
    case 'CH18':
    case 'CH18HS':
    case 'CH20':
    case 'CH20S':
      return 'CH Machine';
    case 'CherokeeB':
      return 'Cherokee Metal';
    case 'Any18HS':
    case 'Any18':
    case 'Any20':
    case 'Any20HS':
      return 'Any';
    case 'Combo16':
    case 'Combo18HS':
    case 'Combo18':
    case 'Combo20':
    case 'Combo20HS':
      return 'Combo';

    default:
      assertExhaustiveSwitch(plateType);
  }
}
